<template>
  <div
    class="bg-white text-black dark:text-white dark:bg-primary-1000 min-h-svh"
  >
    <ModalsContainer />
    <RouterView />
  </div>
</template>

<script setup>
import { ModalsContainer } from 'vue-final-modal'
</script>
